import React from 'react';
import { Search, Filter, X, Eye, EyeOff } from 'lucide-react';

const PublicationFilters = ({ filters, onFilterChange, onReset }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-100">
      <div className="flex items-center gap-2 mb-3">
        <div className="bg-[#FF6B00] bg-opacity-10 p-1.5 rounded">
          <Filter size={16} className="text-[#FF6B00]" />
        </div>
        <h2 className="text-sm font-bold text-gray-900">Filtres</h2>
      </div>

      <div className="space-y-3">
        {/* Une seule ligne : Tous les 5 filtres */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-3">
          {/* Recherche */}
          <div className="relative lg:col-span-1">
            <Search size={16} className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Rechercher..."
              value={filters.search}
              onChange={(e) => onFilterChange('search', e.target.value)}
              className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all"
            />
          </div>

          {/* Visibilité */}
          <select
            value={filters.est_masquee}
            onChange={(e) => onFilterChange('est_masquee', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all appearance-none bg-white cursor-pointer"
          >
            <option value="">📋 Toutes</option>
            <option value="false">✅ Visibles</option>
            <option value="true">🚫 Masquées</option>
          </select>

          {/* Date début */}
          <input
            type="date"
            value={filters.date_debut}
            onChange={(e) => onFilterChange('date_debut', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all"
          />

          {/* Date fin */}
          <input
            type="date"
            value={filters.date_fin}
            onChange={(e) => onFilterChange('date_fin', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all"
          />

          {/* Tri */}
          <select
            value={filters.ordering}
            onChange={(e) => onFilterChange('ordering', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all appearance-none bg-white cursor-pointer"
          >
            <option value="-created_at">📅 Plus récentes</option>
            <option value="created_at">📅 Plus anciennes</option>
            <option value="-nombre_signalements">⚠️ Plus signalées</option>
            <option value="utilisateur__username">👤 Par utilisateur</option>
          </select>
        </div>

        {/* Ligne 2 : Filtres actifs et Reset */}
        {(filters.search || filters.est_masquee || filters.date_debut || filters.date_fin) && (
          <div className="flex items-center justify-between pt-2 border-t border-gray-200">
            <div className="flex flex-wrap gap-1.5">
              {filters.search && (
                <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium flex items-center gap-1">
                  <Search size={10} />
                  <button onClick={() => onFilterChange('search', '')} className="hover:bg-blue-200 rounded-full">
                    <X size={12} />
                  </button>
                </span>
              )}
              {filters.est_masquee && (
                <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium flex items-center gap-1">
                  {filters.est_masquee === 'true' ? <EyeOff size={10} /> : <Eye size={10} />}
                  <button onClick={() => onFilterChange('est_masquee', '')} className="hover:bg-purple-200 rounded-full">
                    <X size={12} />
                  </button>
                </span>
              )}
              {filters.date_debut && (
                <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center gap-1">
                  Début
                  <button onClick={() => onFilterChange('date_debut', '')} className="hover:bg-green-200 rounded-full">
                    <X size={12} />
                  </button>
                </span>
              )}
              {filters.date_fin && (
                <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center gap-1">
                  Fin
                  <button onClick={() => onFilterChange('date_fin', '')} className="hover:bg-green-200 rounded-full">
                    <X size={12} />
                  </button>
                </span>
              )}
            </div>

            {/* Bouton reset compact */}
            <button
              onClick={onReset}
              className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-1.5 text-xs font-medium"
            >
              <X size={14} />
              Reset
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicationFilters;
